export enum TechnicianRankingIndicatorsOrderingEnum {
    USER = 'USER',
    TOTAL_CUSTOMERS_WITH_EVOLUTION = 'TOTAL_CUSTOMERS_WITH_EVOLUTION',
    TOTAL_TREATMENTS_CONCLUDED = 'TOTAL_TREATMENTS_CONCLUDED',
    TOTAL_SALES_IN_APPLICATION_ROOM = 'TOTAL_SALES_IN_APPLICATION_ROOM',
    SALE_VALUE_IN_APPLICATION_ROOM = 'SALE_VALUE_IN_APPLICATION_ROOM',
    SALE_VALUE_AVERAGE_IN_APPLICATION_ROOM = 'SALE_VALUE_AVERAGE_IN_APPLICATION_ROOM',
}
